import { PriceRow } from 'components/Product/ProductPrice';
import React, { CSSProperties, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Language, Product } from 'types/schema';
import utilsMessages from 'utils/messages';
import calculateVAT from '../../../utils/calculateVAT';
import formatMoney, { formatCurrency } from '../../../utils/formatMoney';
import Money from 'components/Money/Money';

export const PriceText = styled.p`
  color: #595959;
  font-size: 16px;
  font-weight: 700;
`;

const VAT = styled.p`
  font-family: 'Inter';
  font-size: 12px;
  font-weight: 500;
  color: #585a60;
  font-style: italic;
`;

export interface PriceProps {
  style?: CSSProperties;
  product: Product;
  baseUom?: string;
  baseUomPrice?: number;
  netUom?: string;
  uom?: string;
  lang?: Language;
}

const PriceContainer = styled.div`
  height: 54px;
  margin-top: 5px;
`;

const DiscountPrice = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #3c9041;
`;
const PerPrice = styled.p`
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  color: #808289;
`;
const BasePrice = styled.p`
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  color: #aaacb2;
  text-decoration: line-through;
`;

export const Price = ({ product, baseUom, netUom }: PriceProps) => {
  const { baseUnit, netUnit, beforeVat, priceV2, baseUomPrice, netUomPrice } = product;
  const renderUomPrice = useMemo(() => {
    if (baseUomPrice && baseUnit !== 1) {
      return (
        <PerPrice>
          ({formatCurrency(calculateVAT(baseUomPrice, priceV2?.vat, priceV2?.vatIncluded).beforeVat, 1)}/
          <span style={{ textTransform: 'capitalize' }}>{baseUom}</span>)
        </PerPrice>
      );
    }

    if (netUomPrice && netUnit !== 1) {
      return (
        <PerPrice>
          ({formatCurrency(calculateVAT(netUomPrice, priceV2?.vat, priceV2?.vatIncluded).beforeVat, 1)}/
          <span style={{ textTransform: 'capitalize' }}>{netUom}</span>)
        </PerPrice>
      );
    }
    return '';
  }, [baseUomPrice, baseUom, netUomPrice, netUom]);

  return (
    <PriceContainer>
      <PriceRow>
        <DiscountPrice>
          {formatMoney(calculateVAT(priceV2?.price, priceV2?.vat, priceV2?.vatIncluded).beforeVat)}
          <span style={{ fontSize: 14 }}>₫</span>
        </DiscountPrice>
        {priceV2 && priceV2?.originalPrice > priceV2?.price ? (
          <BasePrice>
            <Money>{calculateVAT(priceV2?.originalPrice, priceV2?.vat, priceV2?.vatIncluded).beforeVat}</Money>
          </BasePrice>
        ) : null}
      </PriceRow>
      {renderUomPrice}
      <VAT>
        (<FormattedMessage {...utilsMessages.vatNotIncluded} />)
      </VAT>
    </PriceContainer>
  );
};
